import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CompaniesList } from '@/pages/super-admin/company-list';

const companiesSearchSchema = z.object({
	page: z.coerce.number().default(1),
	limit: z.coerce.number().default(10),
	search: z.string().optional(),
	sortBy: z.enum(['name', 'createdAt', 'planEndAt']).default('name'),
	sortOrder: z.enum(['asc', 'desc']).default('asc'),
	plan: z.enum(['FREE', 'TRIAL', 'START', 'STANDARD', 'PREMIUM']).optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/companies/')({
	component: CompaniesList,
	validateSearch: companiesSearchSchema,
});
